<template>
    <div class="page">
        <div class="top">
            <el-button @click="$router.go(-1)" type="default" size="medium">返回</el-button>
            <el-button size="medium" type="primary" @click="applyEmpower()" v-if="isShowByPermission('/wyms/auth/insertAuthLoginZ')">申请授权</el-button>
        </div>
        <div class="content">
            <el-table
                :height="windowHeight - 245"
                :data="authList"
                style="width: 100%"
            >
                <el-table-column
                    label="授权人"
                    align="center"
                    prop="authName"
                >
                </el-table-column>
                <el-table-column
                    label="授权时间"
                    align="center"
                    prop="createdTime"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">{{scope.row.createdTime | timeFormat}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="状态"
                    align="center"
                >
                    <template slot-scope="scope">
                        <span>{{['待通过', '通过', '不通过'][scope.row.status]}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="授权登录时间"
                    align="center"
                >
                    <template slot-scope="scope">
                        <span v-if="scope.row.status == 1">{{scope.row.loginTime | timeFormat}}</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>

                <el-table-column
                    label="操作"
                    align="center"
                    v-if="isShowByPermission('/wyms/auth/updateRunasAuthLogin')"
                >
                    <template slot-scope="scope">
                        <el-button @click="loginFunc(scope.row)" :disabled="scope.row.status != 1" type="text">登录
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>

        <el-dialog title="授权登录" :visible.sync="isShowDialog" :close-on-press-escape='false'
                   width="500px"
                   :lock-scroll="false"
                   :close-on-click-modal='false' :modal-append-to-body='false'>
            <div>
                <el-form ref="authForm" :model="authForm" :rules="authFormRules"
                         label-width="140px">
                    <el-form-item label="经销商" prop="businessId">
                        <el-select filterable @change="queryBusinessNumberListFunc" v-model.trim="authForm.businessId" placeholder="请选择">
                            <el-option v-for="item in bussinessList" :key="item.id" :label="item.bussinessName"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="授权客服" prop="userId">
                        <el-select filterable @change="querySchoolListByUserIdFunc" v-model.trim="authForm.userId" placeholder="请选择">
                            <el-option v-for="item in userList" :key="item.userId" :label="item.name"
                                       :value="item.userId">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="授权学校" prop="schoolIds">
                        <el-select filterable multiple v-model="authForm.schoolIds" placeholder="请选择">
                            <el-option v-for="item in schoolList" :key="item.id" :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="medium" @click="isShowDialog = false">取 消</el-button>
                <el-button size="medium" type="primary" @click="applyEmpowerConfirm()">确定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import BackTool from '@/components/BackTool';
    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {queryAuthLoginList, updateRunasAuthLogin, querySchoolListByUserId, queryBusinessNumberList, queryBussinessListAll, insertAuthLogin} from '@/api/empower';

    export default {
        name: 'empowerHistoryList',
        components: {BackTool},
        mixins: [windowResize, baseMixin],
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : ''
            }
        },
        data() {
            return {
                bussinessList: [],
                authList: [],
                userList: [],
                schoolList: [],
                isShowDialog: false,
                authForm: {
                    businessId: '',
                    userId: '',
                    name: '',
                    schoolIds: []
                },
                authFormRules: {
                    businessId: [
                        { required: true, message: '请选择经销商', trigger: 'blur' },
                    ],
                    userId: [
                        { required: true, message: '请选择授权客服', trigger: 'blur' },
                    ],
                    schoolIds: [
                        { required: true, message: '请选择授权学校', trigger: 'blur' },
                    ]
                }
            }
        },
        created() {
            this.queryAuthLoginListFunc();
        },
        methods: {
            isShowByPermission,
            applyEmpower() {
                queryBussinessListAll()
                    .then(data => {
                        this.bussinessList = data;
                        if(data && data.length !== 0) {
                            this.authForm.businessId = data[0].id;
                            this.queryBusinessNumberListFunc();
                        } else {
                            this.authForm.businessId = '';
                        }
                        this.isShowDialog = true;
                    });
            },
            applyEmpowerConfirm() {
                this.$refs.authForm.validate(isValid => {
                    if(isValid) {
                        const userObj = this.userList.find(userItem => userItem.userId == this.authForm.userId);
                        insertAuthLogin({
                            id: userObj.userId,
                            loginname: userObj.loginname,
                            name: userObj.name,
                            schoolIds: this.authForm.schoolIds.join(',')
                        })
                            .then(() => {
                                this.$message.success('已发送申请');
                                this.isShowDialog = false;
                                this.queryAuthLoginListFunc();
                            })
                    }
                })
            },
            sizeChangeHandler() {
                this.queryAuthLoginListFunc();
            },
            currentChangeHandler() {
                this.queryAuthLoginListFunc();
            },
            queryAuthLoginListFunc() {
                queryAuthLoginList({
                    searchVal: '',
                    status: '',
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize
                })
                    .then(data => {
                        this.authList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            },
            loginFunc(item) {
                updateRunasAuthLogin({
                    id: item.id,
                    userId: item.authId,
                })
                    .then(() => {
                        setTimeout(() => {
                            window.location.reload();
                        }, 200);
                        this.$router.push('/main/customService/schoolManage/schoolList');
                    })
            },
            queryBusinessNumberListFunc() {
                queryBusinessNumberList({
                    businessId: this.authForm.businessId
                })
                    .then(data => {
                        this.userList = data;
                        if(data && data.length !== 0) {
                            this.authForm.userId = data[0].userId;
                            this.querySchoolListByUserIdFunc();
                        } else {
                            this.authForm.userId = '';
                        }
                    })
            },
            querySchoolListByUserIdFunc() {
                querySchoolListByUserId({
                    userId: this.authForm.userId
                })
                    .then(data => {
                        this.authForm.schoolIds = [];
                        this.schoolList = data;
                    })
            }
        }
    }
</script>

<style scoped>
  .page{
    padding:12px
}
 .top {
    border-bottom: 1px solid #e7eaec;
    padding-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/empower/empowerHistoryList.vue